import styled, { css } from 'styled-components';

export const MobileMenuContainer = styled.div`
  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: none;
    visibility: hidden;
  }
`;

export const BottomNavigation = styled.div<{ show?: boolean }>`
  height: 48px;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  position: fixed;
  width: 100%;
  z-index: 15;
  background-color: ${({ theme }) => theme.UI_COLORS.secondary};

  & > a,
  & > button {
    ${({ show = true }) =>
      !show &&
      css`
        display: none;
      `}
  }
`;

export const BottomSearch = styled.div<{ show?: boolean }>`
  display: flex;
  ${({ show = true }) =>
    !show &&
    css`
      display: none;
    `}

  & > button,
  & > div {
    margin-left: 1rem;
  }

  & > button {
    margin-right: 1rem;
  }

  input {
    display: block;
    width: 100%;
  }
`;

export const BottomNavigationButton = styled.button<{ active?: boolean }>`
  border: 0;
  background-color: transparent;
  outline: none;
  color: ${({ theme, active = false }) =>
    active ? theme.UI_COLORS.primary : theme.UI_COLORS.light};
  transition: all 0.3s ease-in-out;
  font-size: 1.1rem;
  text-decoration: none;
  text-align: center;

  svg {
    transition: all 0.3s ease-in-out;
    fill: ${({ theme, active = false }) =>
      active ? theme.UI_COLORS.primary : theme.UI_COLORS.light};
  }

  &.active {
    color: ${({ theme }) => theme.UI_COLORS.primary};
    svg {
      transition: all 0.3s ease-in-out;
      fill: ${({ theme }) => theme.UI_COLORS.primary};
    }
  }

  &.search {
    display: none;
    visibility: hidden;

    @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
      display: flex;
      visibility: visible;
    }
  }
`;

export const SideMenuStyle = styled.div<{ show: boolean }>`
  width: 90vw;
  max-width: 330px;
  height: 100vh;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.5s cubic-bezier(0, 0.52, 0, 1);
  overflow: scroll;
  z-index: 10;
  padding-bottom: calc(3rem + 48px);
  box-sizing: border-box;

  ${({ show }) =>
    show
      ? css`
          transform: translate3d(0vw, 0, 0);
          overflow: hidden;
        `
      : css`
          transform: translate3d(-100vw, 0, 0);
        `}

  & > div.first-level {
    padding: 3rem;
    background-color: #f6f7f9;
  }
  & > div.second-level {
    padding: 3rem;
  }
`;

export const SideMenuBackground = styled(SideMenuStyle)`
  width: 100vw;
  max-width: none;
  background-color: rgba(0, 0, 0, 0.3);
`;

export const CourseLinks = styled.div`
  & > a {
    color: ${({ theme }) => theme.UI_COLORS.secondary};
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: 1.5rem 0;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
    font-weight: 500;

    & > span {
      padding-left: 2rem;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

export const SideMenuFirstLevelStyle = styled.div`
  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
  font-weight: 500;

  & > div > span {
    padding-left: 2rem;
  }
  & > div.profile {
    display: flex;
    align-items: center;

    & > svg {
      fill: ${({ theme }) => theme.UI_COLORS.primary};
    }
  }
`;

export const MobileSubMenuStyle = styled.div<{ show: boolean }>`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.5s cubic-bezier(0, 0.52, 0, 1);
  overflow: auto;
  z-index: 12;
  padding-bottom: calc(3rem + 48px);
  box-sizing: border-box;

  ${({ show }) =>
    show
      ? css`
          transform: translate3d(0vw, 0, 0);
          overflow-x: hidden;
        `
      : css`
          transform: translate3d(-100vw, 0, 0);
        `}

  & > h2 {
    display: flex;
    align-items: center;
    font-size: 2.4rem;
    font-weight: 300;
    padding: 2rem 3.5rem;
    margin: 0;

    & > svg {
      fill: ${({ theme }) => theme.UI_COLORS.primary};
      margin-right: 2rem;
    }
  }
  & > hr {
    margin: 0 0.8rem;
    border-top: 1px solid ${({ theme }) => theme.UI_COLORS.main_gray};
    border-bottom: 0;
  }
`;
